
import { date, showAlert } from '../../../lib/helpers';
import { headers, search, dataMaxSelectedApproval} from './attributes';

export default {
  data: () => ({
    options: {},
    dialog: false,
    dialogApprove: false,
    dialogName: '',
    headers,
    editedIndex: -1,
    search,
    datePengajuanVal: [],
    selectedRow: '',
    selectedData: [],
    selectAllData: false,
    maxSelected: dataMaxSelectedApproval,
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.forceActiveMerchant.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.forceActiveMerchant.flashError;
      },
      set() {
        this.$store.commit('forceActiveMerchant/setFlashErrorMessage', '');
      },
    },
    loading() {
      return this.$store.state.forceActiveMerchant.loading;
    },
    allData() {
      return this.$store.state.forceActiveMerchant.allData;
    },
    totalPage() {
      return this.$store.state.forceActiveMerchant.totalPage;
    },
    totalData() {
      return this.$store.state.forceActiveMerchant.totalData;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('forceActiveMerchant/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
    selectedData: {
      handler() {
        if (this.selectedData.length > this.maxSelected) {
          showAlert(
            this.$store,
            `Limit selected data is ${this.maxSelected} !`,
            'mdi-alert',
            'red'
          );
          this.selectedData.splice(
            this.maxSelected,
            this.selectedData.length - 1
          );
        }
        this.checkAllSelected();
      },
    },
  },

  methods: {
    changeSelectedData(newSelected) {
      this.selectedData = newSelected;
    },
    changeSelectAllData(newSelectedAll) {
      this.selectAllData = newSelectedAll;
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.mid = '';
      this.search.reference_number = '';
      this.$nextTick(() => {
        this.$store.commit('forceActiveMerchant/clearData');
        this.showData(this.datePengajuanVal);
      });
    },

    openApproveModal() {
      this.dialogName = 'approve';
      if (this.selectedData.length < 1) {
        this.dialogApprove = false;
        showAlert(this.$store, 'Data must be selected!', 'mdi-alert', 'red');
      } else {
        this.dialogApprove = true;
      }
    },
    openRejectModal() {
      this.dialogName = 'reject';
      if (this.selectedData.length < 1) {
        this.dialogApprove = false;
        showAlert(this.$store, 'Data must be selected!', 'mdi-alert', 'red');
      } else {
        this.dialogApprove = true;
      }
    },

    clearSelected() {
      this.selectedData = [];
      this.selectAllData = false;
    },

    confirm(type) {
      this.$store
        .dispatch('forceActiveMerchant/bulk_confirm', {
          date,
          id: this.selectedData,
          type,
        })
        .then((res) => {
          if (res !== false) {
            this.clearSelected();
            this.getData();
            showAlert(
              this.$store,
              `${type} success !`,
              'mdi-check-circle',
              'green'
            );
          }
        })
        .finally(() => {
          this.dialogApprove = false;
        });
    },

    getData() {
      this.$store.commit('forceActiveMerchant/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('forceActiveMerchant/fetchDataForceActiveMerchant', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          type: 'approval',
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          }
        })
        .finally(() => {
          this.checkAllSelected();
        });
    },

    checkAllSelected() {
      const allIds = this.allData.map((val) => val.id);
      const allSelected = allIds.filter(
        (val) => !this.selectedData.includes(val)
      );
      if (
        allSelected.length === 0 &&
        this.selectedData.length > 0 &&
        this.allData.length > 0
      ) {
        this.selectAllData = true;
      } else {
        this.selectAllData = false;
      }
    },

    closeFlash() {
      this.$store.commit('forceActiveMerchant/setFlashErrorMessage', '');
    },

    exportItem() {
      if (this.totalData <= 0) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('forceActiveMerchant/clearData');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          exportUrl: 'api/v1/export/export-force-active-approver/index',
          exportController: 'export-force-active-approver',
        });
      }
    },
  },
};